import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Avatar,
  Button,
  Icon
} from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { FiUser, FiLogOut } from 'react-icons/fi'

const UserMenu = () => {
  const navigate = useNavigate()

  // Safely get user data from session storage
  const getUserData = () => {
    try {
      const userData = sessionStorage.getItem('user')
      return userData ? JSON.parse(userData) : {}
    } catch (error) {
      console.error('Error parsing user data:', error)
      return {}
    }
  }

  const user = getUserData()

  const handleLogout = () => {
    // Clear session storage
    sessionStorage.removeItem('user')
    sessionStorage.removeItem('token')
    sessionStorage.removeItem('refreshToken')
    
    // Redirect to login page
    navigate('/login', { replace: true })
  }

  return (
    <Menu>
      <MenuButton
        as={Button}
        rounded={'full'}
        variant={'link'}
        cursor={'pointer'}
        minW={0}
      >
        <Avatar 
          size={'sm'} 
          name={user.first_name ? `${user.first_name} ${user.last_name || ''}` : user.email || 'User'}
          src={user.avatar}
        />
      </MenuButton>
      <MenuList>
        <MenuItem as='a' href='/dashboard/profile'>
          <Icon as={FiUser} mr={2} />
          Profile
        </MenuItem>
        <MenuItem color="red.500" onClick={handleLogout}>
          <Icon as={FiLogOut} mr={2} />
          Logout
        </MenuItem>
      </MenuList>
    </Menu>
  )
}

export default UserMenu